import { PageGroup } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { VLayout } from '@sleepstation/components-layouts'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import camelCase from 'camelcase'
import BreakoutModuleNarrow from '../../../shared/breakoutModules/BreakoutModuleWide/BreakoutModuleWide'
import ResourcesGroup from './ResourcesGroup'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

// eslint-disable-next-line react/prop-types
const buildHeader = ({ title, body }) => (
  <BreakoutModuleNarrow
    hasGradient
    hasBottomBorder
    paddingV={[
      [1, 0],
      [1.25, 1],
      [2, 2],
    ]}
  >
    <PageGroup title={title} isClose>
      <CopyParagraph>{body}</CopyParagraph>
    </PageGroup>
  </BreakoutModuleNarrow>
)

const buildResourceSections = (resources, resourceCategories) =>
  resourceCategories.map((category) => {
    const { edges } = resources[camelCase(category)]
    const resourcesExistInCategory = edges.length !== 0

    return (
      resourcesExistInCategory && (
        <BreakoutModuleNarrow
          hasGradient
          paddingV={[
            [1, 2],
            [2, 3],
            [2, 4],
          ]}
          key={category}
        >
          <ResourcesGroup
            title={category}
            resources={edges}
            dataCy={`${camelCase(category)}-resource-group`}
          />
        </BreakoutModuleNarrow>
      )
    )
  })

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({ 'data-cy': `resource-groups` })`
  overflow: hidden;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Resources = ({ content, resources, resourceCategories }) => (
  <Layout>
    {buildHeader(content.header)}
    {buildResourceSections(resources, resourceCategories)}
  </Layout>
)

Resources.propTypes = {
  resources: PropTypes.object.isRequired,
  content: PropTypes.object.isRequired,
  resourceCategories: PropTypes.array.isRequired,
}

Resources.defaultProps = {}

export default Resources
